module.exports = __webpack_public_path__ + "img/service-effect-2.f3924a30.png";